import React from "react";
import backendicon from "../assets/images/backendicon.svg";

const BackendSkill = () => {
  return (
    <div className="bg-white shadow-sm py-4 px-5 position-relative">
      <h4 className="text-center mb-3 mt-5">Backend</h4>
      <div className="skills-icon-holder position-absolute d-inline-block rounded-circle text-center bg-light">
        <img className="text-center" src={backendicon} alt="Frontend" />
      </div>
      <ul>
        <li>Node.js</li>
        <li>Express</li>
        <li>MongoDB</li>
        <li>Mongoose</li>
      </ul>
    </div>
  );
};

export default BackendSkill;
